import { QuickBooksInventoryItemTracking } from 'server/models/QuickBooksInventoryItemTracking';

export * from 'server/models/QuickBooksInventoryItemTracking';

export interface IQuickBooksInventoryItemTracking {
    Name : () => string | null;
    Account : () => string | null;
}

export function QuickBooksInventoryItemTrackingWithDefaults(
    overrides : QuickBooksInventoryItemTracking,
    defaults : () => QuickBooksInventoryItemTracking | null
) : IQuickBooksInventoryItemTracking {
    return {
        Name : () => overrides.Name() || (defaults() ? defaults()!.Name() : null),
        Account : () => overrides.Account() || (defaults() ? defaults()!.Account() : null)
    };
}


// WEBPACK FOOTER //
// ./data/models/QuickBooksInventoryItemTracking.ts